import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const tastingMenuCourseTimelineDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.tasting,
  componentType: LAYOUT_COMPONENT_TYPE.tastingMenuCourseTimeline,
  registryBlockKey: REGISTRY_BLOCK.presentation.tastingMenuCourseTimeline,
  displayOrder: 5,
  content: {
    heading: loc3('Degustationsmenü', 'Tasting menu', 'Thực đơn nếm thử'),
    supporting: loc3(
      'Ein kuratierter Abend in sechs Gängen.',
      'A curated evening in six courses.',
      'Một buổi tối được tuyển chọn với 6 món.',
    ),
    courses: loc3(
      'Amuse-Bouche\nMeer & Zitrus\nZwischengang\nHauptgang\nKäse\nDessert',
      'Amuse-bouche\nSea & citrus\nIntermediate course\nMain course\nCheese\nDessert',
      'Khai vị nhỏ\nHải sản & cam quýt\nMón trung gian\nMón chính\nPhô mai\nTráng miệng',
    ),
    pairingWine: loc3(
      'Weinbegleitung 95 € — sechs Gläser, kellergeführt.',
      'Wine pairing 95 € — six glasses, from the cellar.',
      'Kèm rượu 95 € — sáu ly, từ hầm.',
    ),
    pairingZero: loc3(
      'Alkoholfreie Begleitung 55 € — Saft, Tee, Hausauszüge.',
      'Alcohol-free pairing 55 € — juices, teas, house infusions.',
      'Kèm không cồn 55 € — nước ép, trà, ngâm nhà.',
    ),
  },
  media: {},
};

/** Hinoki Omakase Eleven — course timeline with photo collect. */
export const tastingMenuCourseTimelineSushi: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.tasting,
  componentType: LAYOUT_COMPONENT_TYPE.tastingMenuCourseTimeline,
  registryBlockKey: REGISTRY_BLOCK.presentation.tastingMenuCourseTimeline,
  displayOrder: 5,
  content: {
    heading: loc3('Omakase Eleven', 'Omakase Eleven', 'Omakase Eleven'),
    supporting: loc3(
      'Vertrauen in Gänge — Kursfolge statt Formular-Wüste.',
      'Trust the courses — a procession, not a form desert.',
      'Tin vào các món — chuỗi course, không sa mạc form.',
    ),
    courses: loc3(
      'Zensai — Kleine Vorspeisen vom Tagesfang\nNigiri — Sechs Schnitte, Reis mit Geduld\nTamago · Close — Süßes Ei, stiller Abschluss',
      'Zensai — Small starters from the day’s catch\nNigiri — Six cuts, patient rice\nTamago · Close — Sweet egg, quiet finish',
      'Zensai — Khai vị nhỏ từ cá trong ngày\nNigiri — Sáu nhát cắt, cơm kiên nhẫn\nTamago · Close — Trứng ngọt, kết thúc yên',
    ),
    pairingWine: loc3(
      'Sake-Begleitung 85 € — Junmai und Gyokuro zum Schnitt.',
      'Sake pairing 85 € — junmai and gyokuro with the cut.',
      'Kèm sake 85 € — junmai và gyokuro theo nhát cắt.',
    ),
    pairingZero: loc3(
      'Tee-Begleitung 45 € — Gyokuro, Hojicha, Hausinfusion.',
      'Tea pairing 45 € — gyokuro, hojicha, house infusion.',
      'Kèm trà 45 € — gyokuro, hojicha, trà ngâm nhà.',
    ),
  },
  media: {
    courseImage0: '/platform/defaults/menu/restaurant/sushi-sashimi-mori-01.jpg',
    courseImage1: '/platform/defaults/menu/restaurant/sushi-nigiri-sake-01.jpg',
    courseImage2: '/platform/defaults/menu/restaurant/sushi-tamago-01.jpg',
  },
};

export const tastingMenuPairingCardsDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.tastingPairing,
  componentType: LAYOUT_COMPONENT_TYPE.tastingMenuCourseTimeline,
  registryBlockKey: REGISTRY_BLOCK.presentation.tastingMenuPairingCards,
  displayOrder: 5,
  content: {
    heading: loc3('Degustationsmenü', 'Tasting menu', 'Thực đơn nếm thử'),
    supporting: loc3(
      'Ein kuratierter Abend in sechs Gängen. Weinbegleitung und alkoholfreie Begleitung auf Wunsch.',
      'A curated evening in six courses. Wine pairing and an alcohol-free pairing on request.',
      'Một buổi tối sáu món. Kèm rượu và phiên bản không cồn theo yêu cầu.',
    ),
    courses: loc3(
      'Amuse-Bouche\nMeer & Zitrus\nZwischengang\nHauptgang\nKäse\nDessert',
      'Amuse-bouche\nSea & citrus\nIntermediate course\nMain course\nCheese\nDessert',
      'Khai vị nhỏ\nHải sản & cam quýt\nMón trung gian\nMón chính\nPhô mai\nTráng miệng',
    ),
    pairingWine: loc3(
      'Weinbegleitung 95 € — sechs Gläser, kellergeführt.',
      'Wine pairing 95 € — six glasses, from the cellar.',
      'Kèm rượu 95 € — sáu ly, từ hầm.',
    ),
    pairingZero: loc3(
      'Alkoholfreie Begleitung 55 € — Saft, Tee, Hausauszüge.',
      'Alcohol-free pairing 55 € — juices, teas, house infusions.',
      'Kèm không cồn 55 € — nước ép, trà, ngâm nhà.',
    ),
  },
  media: {},
};
